<template>
    <div style="height: 95%; overflow-y: auto">
        <b-row style="margin-left: 5px; margin-right: 5px">
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Cognome</label>
                <span>{{ jsonDataAccettazione.accettazioneAnagrafica.cognome }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Nome</label>
                <span>{{ jsonDataAccettazione.accettazioneAnagrafica.nome }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Nato/a</label>
                <span>{{ jsonDataAccettazione.accettazioneAnagrafica.comuneNascita }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Provincia</label>
                <span>{{ jsonDataAccettazione.accettazioneAnagrafica.provinciaNascita }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Data di nascita</label>
                <span>{{ formatDate(jsonDataAccettazione.accettazioneAnagrafica.dataNascita) }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Residente a</label>
                <span>{{ jsonDataAccettazione.accettazioneAnagrafica.comuneResidenza }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Provincia</label>
                <span>{{ jsonDataAccettazione.accettazioneAnagrafica.provinciaResidenza }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Via</label>
                {{ jsonDataAccettazione.accettazioneAnagrafica.indirizzoResidenza }}
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Codice Fiscale</label>
                <span>{{ jsonDataAccettazione.accettazioneAnagrafica.identificativo }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Cellulare</label>
                <span>{{ jsonDataAccettazione.accettazioneAnagrafica.telefono }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">E-mail</label>
                <span>{{ jsonDataAccettazione.accettazioneAnagrafica.email }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Diagnosi in Ingresso</label>
                <span>{{ jsonDataAccettazione.diagnosiIngresso }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Terapia Prescritta</label>
                <span>{{ jsonData.terapiaPrescritta }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Frequenza</label>
                <span>{{ jsonData.frequenza }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Medico Prescrittore</label>
                <span>{{ jsonData.medicoPrescrittore }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Allergico a medicinali</label>
                <span>{{ jsonData.allergicoMedicinali }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Portatore di protesi</label>
                <span>{{ jsonData.portatoreProtesi }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Quali?</label>
                <span>{{ jsonData.allergicoMedicinaliQuali }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Quali?</label>
                {{ jsonData.portatoreProtesiQuali }}
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Portatore di pacemaker</label>
                <span>{{ jsonData.portatorePacemaker }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Affetto da epatite B o C</label>
                <span>{{ jsonData.affettoEpatite }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">In stato di gravidanza</label>
                <span>{{ jsonData.statoGravidanza }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Affetto da TBC</label>
                <span>{{ jsonData.affettoTbc }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Affetto da HIV</label>
                <span>{{ jsonData.affettoHiv }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Affetto da neoplasie oggi</label>
                <span>{{ jsonData.affettoNeoplasieOggi }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">E' stato affetto da neoplasie negli ultimi 5 anni?</label>
                <span>{{ jsonData.affettoNeoplasieUltimiCinqueAnni }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Quali?</label>
                <span>{{ jsonData.affettoNeoplasieOggiQuali }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Quali?</label>
                <span>{{ jsonData.affettoNeoplasieUltimiCinqueAnniQuali }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Altre patologie</label>
                <span>{{ jsonData.altrePatologie }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Intensità del dolore paziente in entrata: {{ jsonData.scalaDoloreEntrata }} </label>
                <b-form-input v-model="jsonData.scalaDoloreEntrata" type="range" min="0" max="10" step="1" :disabled="true">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                    </template>
                </b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Intensità del dolore paziente in uscita: {{ jsonData.scalaDoloreUscita }} </label>
                <b-form-input v-model="jsonData.scalaDoloreUscita" type="range" min="0" max="10" step="1" :disabled="true">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                    </template>
                </b-form-input>
            </b-col>
            <!--     <b-card class="sa-card sa-card-border" header="Struttura - Presidio" header-tag="header" footer-tag="footer" title="">
                <b-row> -->
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data"><strong>Esami Consegnati</strong></label>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">RX</label>
                <span>{{ jsonData.esamiConsegnatiRx }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">RM</label>
                <span>{{ jsonData.esamiConsegnatiRm }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">TAC</label>
                <span>{{ jsonData.esamiConsegnatiTac }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">MOC</label>
                <span>{{ jsonData.esamiConsegnatiMoc }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">ECOX</label>
                <span>{{ jsonData.esamiConsegnatiEcox }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">EMG</label>
                <span>{{ jsonData.esamiConsegnatiEmg }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <label class="sa-label-data">Altro</label>
                <span>{{ jsonData.esamiConsegnatiAltro }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                <label class="sa-label-data">Dettaglio</label>
                <span>{{ jsonData.esamiConsegnatiAltroDettaglio }}</span>
            </b-col>
            <!--    </b-row>
            </b-card> -->
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Note</label>
                <span>{{ jsonData.note }}</span>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import "vue2-datepicker/index.css";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    components: {},
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            pathResource: "/rsaschedapaziente",
            id: null,
            jsonData: {
                affettoEpatite: "",
                affettoHiv: "",
                affettoNeoplasieOggi: "",
                affettoNeoplasieOggiQuali: "",
                affettoNeoplasieUltimiCinqueAnni: "",
                affettoNeoplasieUltimiCinqueAnniQuali: "",
                affettoTbc: "",
                allergicoMedicinali: "",
                allergicoMedicinaliQuali: "",
                altrePatologie: "",
                createDate: "",
                createUser: "",
                esamiConsegnatiAltro: "",
                esamiConsegnatiAltroDettaglio: "",
                esamiConsegnatiEcox: "",
                esamiConsegnatiEmg: "",
                esamiConsegnatiMoc: "",
                esamiConsegnatiRm: "",
                esamiConsegnatiRx: "",
                esamiConsegnatiTac: "",
                frequenza: "",
                id: "",
                idAccettazione: "",
                medicoPrescrittore: "",
                note: "",
                portatorePacemaker: "",
                portatoreProtesi: "",
                portatoreProtesiQuali: "",
                proprietario: "",
                scalaDoloreEntrata: "",
                scalaDoloreUscita: "",
                statoGravidanza: "",
                terapiaPrescritta: "",
                updateDate: "",
                updateUser: "",
            },
            jsonDataAccettazione: {
                accettazioneAnagrafica: {},
            },
            sinoOptions: [
                { text: "- Selezionare Valore -", value: null },
                { text: "SI", value: "SI" },
                { text: "NO", value: "NO" },
            ],
        };
    },
    mounted() {},
    watch: {},
    computed: {},
    methods: {
        init(jsonDataAccettazione) {
            let me = this;
            me.jsonDataAccettazione = jsonDataAccettazione;
            me.idAccettazione = jsonDataAccettazione.id;
            me.jsonData.idAccettazione = me.idAccettazione;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.openShowModalLoading();
            me.loadDataResources(me.pathResource + "/accettazione/" + me.idAccettazione, {}, me.resultResponseData, me.resultErrorData);
        },
        resultResponseData(response) {
            let me = this;
            me.closeShowModalLoading();
            me.jsonData = response.data.data;
            me.$emit("afterLoadData", me.jsonData);
        },
        resultErrorData(error) {
            let me = this;
            me.closeShowModalLoading();
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "";
            if (error.response.status === 404) {
                me.$bvToast.toast("Compilare Scheda Paziente", {
                    title: "Risorsa Non Trovata",
                    autoHideDelay: 5000,
                    variant: "warning",
                });
            } else {
                me.$bvToast.toast(messaggio, {
                    title: "Errore",
                    autoHideDelay: 5000,
                    variant: "danger",
                });
            }
        },
    },
};
</script>
